import { progressiveComponent } from 'site-modules/shared/components/progressive-component/progressive-component';

export const TrimPricingBarsFooterProgressive = progressiveComponent({
  fullComponent: {
    loader: () =>
      import(
        // eslint-disable-next-line import/extensions
        /* webpackChunkName: "trim-pricing-bars-footer" */ 'site-modules/shared/components/core-page/trim-pricing-bars/trim-pricing-bars-footer/trim-pricing-bars-footer.jsx'
      ),
    name: 'TrimPricingBarsFooter',
  },
});
